
export default {
  'navbar.lang': 'English',
  'menu.home': 'Home',
  'menu.dashboard': 'Dashboard',
  'menu.profile': 'Profile',
  'menu.settings': 'Settings',

  'user.login.title': 'Scan Successful!',
  'user.login.subtitle': 'Provide your details to continue',
  'user.login.username': 'Username or email',
  'user.login.password': 'Password',
  'user.login.forgot': 'Forgot password?',
  'user.login.button': 'Sign in',

  'user.register.title': 'Create a new account',
  'user.register.button': 'Sign up',
  'user.register.success': 'Account created. Check email to verify.',

  'user.login.welcome.subheading': 'Welcome to a world where freedom meets unique living! Scan. Earn points. Live free. Live uniquely',
  'user.login.description': 'You successfully scanned our QR code. Sign in or register below to claim rewards, points and win amazing prizes',
  'user.login.signin.title': 'Sign In',
  'user.login.signin.sub': 'To sign in please enter your phone number; we will send a verification code',
  'user.login.phoneNumberLabel': 'Phone Number',
  'user.login.enterPhonePlaceholder': 'Enter phone number',
  'user.login.invalidPhone': 'Invalid phone number',
  'user.login.phoneRequired': 'Phone number is required',
  'user.login.signingIn': 'Signing in...',
  'user.login.continue': 'Continue',
  'user.login.noAccount': "Don't have an account?",
  'user.login.signup': 'Sign up',
  'user.login.footerCopyright': 'Copyright © {year}. Powered by Exceptional Brands',

  'user.register.welcome': 'Welcome!',
  'user.register': 'Sign up to claim your rewards',
  'user.register.description': 'Complete your details below to earn points, unlock rewards and win amazing prizes',
  'user.register.phone.label': 'Phone Number',
  'user.register.phone.placeholder': 'Enter phone number',
  'user.register.phone.required': 'Phone number is required',
  'user.register.phone.invalid': 'Invalid phone number',
  'user.register.name.label': 'Your Name',
  'user.register.name.placeholder': 'e.g. Mark',
  'user.register.name.required': 'Name is required',
  'user.register.ageGroup.label': 'Age group (Optional)',
  'user.register.gender.label': 'Gender (Optional)',
  'user.register.gender.male': 'Male',
  'user.register.gender.female': 'Female',
  'user.register.terms.agreement': 'By proceeding, you agree to our {termsLink} and {privacyLink}.',
  'user.register.terms.termsOfService': 'Terms of Service',
  'user.register.terms.privacyPolicy': 'Privacy Policy',
  'user.register.creating': 'Creating Profile…',
  'user.register.create': 'Create Profile',
  'user.register.alreadyAccount': 'Already have an account?',
  'user.register.signin': 'Sign in',
  'user.register.footer.copyright': 'Copyright © {year}. Powered by Exceptional Brands',

  "user.welcome.welcome": "Welcome!",
  "user.welcome.welcome_name": "Welcome {name}!",
  'user.welcome.points_earned': 'Congratulations, you have earned',
  'user.welcome.thank_you': 'Thank you for signing up!',
  'user.welcome.earn_more_points': 'To earn more points, rate more products you have bought from us.',
  'user.welcome.continue': 'Continue',
  'user.welcome.logging_in': 'Logging in...',
  "user.welcome.welcome_reward": "Welcome reward",
  "user.welcome.points_label": "points!",
  "user.welcome.loggingIn": "Logging in...",

  "product.button.continue": "Continue",
  "product.button.selectToContinue": "Select a product to continue",

  'scansuccess.review.heading': 'How would you rate this product?',
  'scansuccess.review.continue': 'Retailer code (Optional)',
  'scansuccess.review.select-product': 'Add a retailer code to earn more points',
  'scansuccess.review.review-products': 'Submit Review',

  "product.retailerCode.label": "Retailer Code",
  "product.retailerCode.requiredLabel": "Required",
  "product.retailerCode.optionalLabel": "Optional",
  "product.retailerCode.placeholder": "Enter retailer code",
  "product.retailerCode.aria": "Retailer code",
  "product.retailerCode.hintRequired": "Retailer code is required to submit this review",
  "product.retailerCode.hintOptional": "Add a retailer code to earn more points",
  "product.retailerCode.error.required": "Retailer code is required",
  "product.retailerCode.error.invalid": "Invalid retailer code",

  "profile.title": "My Profile",
  "profile.tier.member": "Member",
  "profile.points": "Points",
  "profile.pointsEarned": "Points Earned",
  'scansuccess.continue': 'Continue',
  "profile.completeTitle": "Complete Your Profile",
  "profile.completeSubtitle": "Earn {points} bonus points!",
  "profile.completedTitle": "Profile Completed! ✓",
  "profile.completedSubtitle": "You've earned all {points} bonus points!",
  "profile.completeButton": "Complete Profile (+{points} pt)",
  "profile.redeem": "✓ Profile Complete",
  "product.review.placeholder": "Write a review... (a single character is fine)",
  "product.review.ariaLabel": "Write a review",
  "profile.field.phoneNo.label": "Phone Number",
  "profile.field.phoneNo.add": "Add your phone number",
  "profile.field.email.label": "Email Address",
  "profile.field.email.add": "Add your email",
  "profile.field.countryCode.label": "Location",
  "profile.field.countryCode.add": "Add your location",
  "profile.field.name.label": "Name",
  "profile.field.name.add": "Add your name",
  "profile.field.dateOfBirth.label": "Date of Birth",
  "profile.field.dateOfBirth.add": "Add your date of birth",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Update {field}",
  "profile.modal.completeTitle": "Complete Your Profile",
  "profile.modal.update": "Update",
  "profile.modal.complete": "Complete Profile",
  "profile.modal.cancel": "Cancel",
  "profile.completedBadge": "You earned {points} points",
  "profile.progressPercent": "{percent}% Complete",
  "profile.progressRemaining": "{percent}% remaining",
  'scansuccess.congratulations.heading': 'Congratulations!',
  'scansuccess.congratulations.continue': 'You have earned',
  'scansuccess.congratulations.select-product': 'Thank you for your review',
  'scansuccess.congratulations.review-products': 'To earn more points, rate more products you bought from us',
  'scansuccess.congratulations.create': 'Go to Dashboard',
  'user.brand-product-review.title': 'Select Brand & Product To Continue',
  'user.brand-product-review.continue': 'Continue',
  'user.brand-product-review.select-product': 'Select a product to continue',
  'user.brand-product-review.review-products': 'Review our products to get points',
  'user.brand-product-review.rate-product': 'Please rate at least one product above to continue',
  'user.brand-product-review.footer': 'Copyright © {year}. Powered by Exceptional Brands',
  'scansuccess.title': 'Scan Results',
  'scansuccess.scan.message': 'Thanks — your scan was successful.',
  'scansuccess.scan.instructions': 'You can claim points, write a review or sign up for offers.',
  'scansuccess.signup.title': 'Sign up to claim rewards',
  'scansuccess.signup.button': 'Sign up',
  'scansuccess.welcomepoints.title': 'Welcome Points',
  'scansuccess.welcomepoints.pointsLabel': 'Points awarded',
  'scansuccess.brandproductreview.title': 'Brand & Product Review',
  'scansuccess.brandproductreview.leaveReview': 'Leave a review',
  'scansuccess.productreview.title': 'Product Review',
  'scansuccess.productreview.submit': 'Submit Review',
  'scansuccess.congratulations.title': 'Congratulations!',
  'scansuccess.congratulations.message': 'You earned points — check your dashboard to claim.',
  'scansuccess.noAccount': "Don't have an account?",
  'scansuccess.signup': 'Sign up',

  "user.register.createProfile": "Create Account",
  "user.register.creatingProfile": "Creating Account...",
  "user.register.termsOfService": "Terms of Service",
  "user.register.privacyPolicy": "Privacy Policy",

  'dashboard.multiplescans.title': 'Multiple scans',
  'dashboard.multiplescans.instructions': 'Manage multiple scans and rewards together.',
  'dashboard.title': 'Welcome!',
  'dashboard.balance': 'Your Balance',
  'dashboard.balance-sub': 'points',
  'dashboard.redeem': 'Redeem',
  'dashboard.stat': 'Total scans',
  'dashboard.label': 'Rewards Won',
  'dashboard.redeem.title': 'Redeem Your Points',
  'dashboard.redeem.success': 'Redeem Rewards',
  'dashboard.primary-sub': 'Use your points to unlock rewards',
  'dashboard.secondary-btn': 'Scan again',
  'dashboard.secondary': 'Refer a Friend',
  'dashboard.loyalty': 'Loyalty Tiers',
  'dashboard.5000pts': '5000 points',
  'dashboard.100pts': '100 points to Platinum',
  'dashboard.almost-there': 'Almost there!',
  'dashboard.recent': 'Recent activity',
  'settings.title': 'Settings',

  'settings.balance': 'Gold Member',
  'settings.balance-sub': 'Points',
  'settings.redeem': 'Account',
  'settings.stat': 'Edit Profile',
  'settings.label': 'Update personal information',
  'settings.redeem.title': 'Preferences',
  'settings.redeem.success': 'Notifications',
  'settings.primary-sub': 'Push & email preferences',
  'settings.secondary-btn': 'Language',
  'settings.secondary': 'English (US)',
  'settings.loyalty': 'Help & Terms',
  'settings.5000pts': 'Help & Support',
  'settings.100pts': 'FAQ, contact us',
  'settings.almost-there': 'Terms & Conditions',
  'settings.recent': 'Legal information',
  'settings.points': 'Privacy Policy',
  'settings.data': 'Data protection info',
  'settings.sign': 'Sign out',

  'profile.balance': '% Complete',
  'profile.balance-sub': '% remaining',
  'profile.stat': 'Profile Information',
  'profile.label': 'pt',
  'profile.redeem.title': 'Connect Social Media',
  'profile.redeem.success': 'Earn points for each connection!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Connect your social media for a 20 point bonus!',
  'profile.recent': 'Fill in the following fields to complete your profile and earn ',
 

  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "South Africa",
  "country.BJ": "Benin",
  "country.AE": "United Arab Emirates",

  "dashboard.welcome": "Welcome!",
  "dashboard.user.unknown": "User",
  "dashboard.balanceLabel": "Your Balance",
  "dashboard.coinsAlt": "coins",
  "dashboard.pointsLabel": "points",
  "dashboard.redeemBtn": "Use points",
  "dashboard.totalScans": "Total Scans",
  "dashboard.rewardsWon": "Rewards Won",
  "dashboard.redeemTitle": "Redeem Your Points",
  "dashboard.redeemRewards": "Redeem Rewards",
  "dashboard.redeemSub": "Use your points to unlock rewards",
  "dashboard.reviewProducts": "Review Products",
  "dashboard.referFriend": "Refer Friend",
  "dashboard.tiersTitle": "Loyalty Tiers",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "Almost there!",
  "dashboard.recentActivityTitle": "Recent Activity",
  "dashboard.share.title": "Join Exceptional Brands",
  "dashboard.share.text": "Join me on Exceptional Brands! Earn points by scanning products and get amazing rewards. Use my referral link: {url}",
  "dashboard.shareModalTitle": "Share with Friends",
  "dashboard.shareModalDesc": "Share Exceptional Brands with your friends and earn bonus points when they join!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Your referral link:",
  "dashboard.share.instagramCopied": "Link copied to clipboard - paste into Instagram",
  "dashboard.footerCopyright": "Copyright © {year}. Powered by Exceptional Brands",
  "dashboard.aria.welcome": "Welcome panel",
  "dashboard.aria.notifications": "Notifications",
  "dashboard.aria.settings": "Settings",
  'dashboard.redeem.points': 'Redeem Your Points',
  'dashboard.redeem.subtitle': 'Use your points to unlock rewards',
  'dashboard.redeem.sub': 'points',
  'dashboard.redeem.progress': 'Progress toward Platinum',
  'dashboard.redeem.stat': 'Available Rewards',
  'dashboard.redeem.label': 'Redeem',
  'dashboard.redeem.need': 'Required',
  'dashboard.redeem.prize': 'Prize download',
  'dashboard.redeem.scan': 'The more you scan the higher your chances of winning something awesome',
  'dashboard.redeem.recent': 'Recent Activity',
  'global.back': 'Back',
  'global.next': 'Next',
  'global.search.placeholder': 'Search...',
  'validation.required': 'This field is required',
  'error.404.title': 'Page not found',
  'error.404.subTitle': "Sorry, we can't find the page you are looking for.",
};
